import React from 'react';
import SelectInput from '../../form/controls/SelectInput';
import CommonDataService from '../../../services/CommonDataService';

class TeamDropdown extends React.Component {

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.state = {
      teams: []
    };
  }

  componentDidMount() {
    CommonDataService
      .getTeams()
      .then(teams => this.setState({ teams }));
  }

  onChange(name, value) {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  render() {
    const { onChange, value, options, selected, ...rest } = this.props;
    return (
      <SelectInput
        {...rest}
        onChange={this.onChange}
        value={selected}
        options={this.state.teams} />
    );
  }
}

export default TeamDropdown;



// WEBPACK FOOTER //
// ./src/components/projects/ScheduledProjects/TeamDropdown.js